var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state.player_current_track != null)?_c('div',{staticClass:"player_time"},[_vm._v(" "+_vm._s(_vm.currentTime)+" / "+_vm._s(_vm.totalTime)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }